import { createActionTypes } from "@helpers/redux-helpers";

export const addEmailActionTypes = createActionTypes("addEmail");
export const addEmailModalType = "add-email-modal";
